import { render, staticRenderFns } from "./PageBusinessIntelligence.vue?vue&type=template&id=4baa1f5a&scoped=true"
import script from "./PageBusinessIntelligence.vue?vue&type=script&lang=js"
export * from "./PageBusinessIntelligence.vue?vue&type=script&lang=js"
import style0 from "./PageBusinessIntelligence.vue?vue&type=style&index=0&id=4baa1f5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baa1f5a",
  null
  
)

export default component.exports